import { useState } from 'react';
import { Button, Modal, Switch, Tag } from 'antd';
import { SafetyOutlined, QrcodeOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { useTranslation } from 'react-i18next';
import { getGoogleQrCodeAdminApi, toggleGoogleAuthApi } from '@http/user';

export const GoogleAuth = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const user = useAppSelector(state => state.appReducer.user);
  const [qrModal, setQrModal] = useState(false);
  const [qrCode, setQrCode] = useState<any>(null);
  const [confirmModal, setConfirmModal] = useState(false);

  const handleToggle = async () => {
    if (!user.is_2fa) {
      const qr = await dispatch(getGoogleQrCodeAdminApi() as any);
      if (qr) {
        setQrCode(qr);
        setQrModal(true);
      }
    } else {
      setConfirmModal(true);
    }
  };

  const confirmEnable = async () => {
    await dispatch(toggleGoogleAuthApi() as any);
    setQrModal(false);
    setQrCode(null);
  };

  const confirmDisable = async () => {
    await dispatch(toggleGoogleAuthApi() as any);
    setConfirmModal(false);
  };

  return (
    <div>
      <div
        className='flex items-center justify-between p-4 rounded-xl'
        style={{
          background: user.is_2fa ? '#f0fdf4' : '#fafafa',
          border: '1px solid',
          borderColor: user.is_2fa ? '#bbf7d0' : '#f0f0f0',
        }}
      >
        <div className='flex items-center gap-3'>
          <div
            className='w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0'
            style={{ background: 'linear-gradient(135deg, #011957 0%, #1a3d7c 100%)' }}
          >
            <SafetyOutlined style={{ fontSize: 16, color: '#fff' }} />
          </div>
          <div>
            <p className='text-sm font-medium m-0' style={{ color: '#011957' }}>
              Google Authenticator
            </p>
            <div className='flex items-center gap-2 mt-0.5'>
              <Tag color={user.is_2fa ? 'success' : 'default'} className='m-0 text-xs'>
                {user.is_2fa ? t('Enabled') : t('Disabled')}
              </Tag>
            </div>
          </div>
        </div>
        <Switch
          checked={!!user.is_2fa}
          onChange={handleToggle}
          style={user.is_2fa ? { background: '#011957' } : undefined}
        />
      </div>

      <Modal
        title={
          <div className='flex items-center gap-2'>
            <QrcodeOutlined style={{ color: '#011957' }} />
            <span>{t('Connect Google Auth')}</span>
          </div>
        }
        open={qrModal}
        onCancel={() => {
          setQrModal(false);
          setQrCode(null);
        }}
        footer={
          <div className='flex justify-end gap-2'>
            <Button
              onClick={() => {
                setQrModal(false);
                setQrCode(null);
              }}
            >
              {t('Cancel')}
            </Button>
            <Button type='primary' style={{ background: '#011957' }} onClick={confirmEnable}>
              {t('Enable')}
            </Button>
          </div>
        }
      >
        <div className='text-center py-4'>
          <p className='text-sm text-gray-500 mb-5'>{t('Scan QR code')}</p>
          {qrCode && (
            <div className='inline-block p-3 bg-white rounded-xl shadow border border-gray-100'>
              <img src={qrCode?.secret} alt='QR Code' style={{ width: 200, height: 200, display: 'block' }} />
            </div>
          )}
          <p className='text-xs text-gray-400 mt-5'>{t('After scan click enable')}</p>
        </div>
      </Modal>

      <Modal
        title={t('Disable 2FA title')}
        open={confirmModal}
        onCancel={() => setConfirmModal(false)}
        footer={
          <div className='flex justify-end gap-2'>
            <Button onClick={() => setConfirmModal(false)}>{t('Cancel')}</Button>
            <Button danger type='primary' onClick={confirmDisable}>
              {t('Disable')}
            </Button>
          </div>
        }
      >
        <p className='text-sm text-gray-600'>{t('Disable 2FA confirm')}</p>
      </Modal>
    </div>
  );
};

export default GoogleAuth;
